<div class="row payouts tracker-page">
  <div class="medium-12 columns" style="margin-top: 5px; margin-bottom: 5px;">
    <div class="compose-post float-right" (click)="openCreateTodoPopup()">
      <i class="material-icons">add</i><span>TODO</span>
    </div>
    <div id="company-dropdown" style="width: 25%;margin-right: 10px;" class="float-right filter-option-wrapper-max" *ngIf="allClientsList.length > 0">
      <ng-multiselect-dropdown
        name="company"
        [placeholder]="'Select Clients'"
        [settings]="clientdropdownSettings"
        [data]="allClientsList"
        [(ngModel)]="selectedClients"
        (onSelect)="onClientFilterSelect($event, true)"
        (onDeSelect)="onClientFilterSelect($event, false)"
        (onSelectAll)="onAllClientsFilterSelect($event, true)"
        (onDeSelectAll)="onAllClientsFilterSelect($event, false)">
      </ng-multiselect-dropdown>
    </div>
  </div>
  <div class="medium-12 column">
    <div class="row report-stats word-wrap text-center float-left full-width" *ngIf="hasCountData">
      <div class="large-2 column"></div>
      <div class="column small-12 medium-4 large-4" *ngFor="let chunk of chunkStatus;let i = index">
        <div class="row">
          <div class="column pointer medium-4" *ngFor="let status of chunk" [ngStyle]="{'background': status.colorCode}"
               [ngClass]="{'selected': view == status.status, 'medium-6': chunk.length == 2,'medium-3': chunk.length == 3, 'medium-12': chunk.length == 1}"
               (click)="toggle(status.status)">
            <div class="status-ellipsis" style="text-transform: capitalize">{{ status.status }}</div>
            <div>{{ status.count }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row add-share-buttons" style="margin-left: 2rem; width: 20vw;">
    <div class="medium-10 small-12 invoice-dropdown" foundation [ngStyle]="{'display': selectedTableRows.length>0 ? 'block':'none'}">
      <button class="dropdown button" type="button" data-toggle="recent-actions">Action</button>
      <ul class="dropdown-pane" id="recent-actions" data-dropdown data-close-on-click="true">
        <li  class="pointer" style="padding: 5px 0px 5px 5px" *ngFor="let action of actions" (click)="handleMultipleActions(action.value, action.name)"><span>{{action.name}}</span></li>
      </ul>
    </div>
    <div class="column medium-2 selection-count" style="margin-top: 6px" [ngStyle]="{'display': selectedTableRows.length>0 ? 'block':'none'}"><span *ngIf="!bulkSelectAll">{{selectedTableRows.length}}</span><span *ngIf="bulkSelectAll && bulkSelectCount">{{bulkSelectCount}}</span><span style="padding-left: 5px">selected</span></div>
  </div>
  <div class="column medium-12 large-12 indy-tables badge-tables firm-todo-table">
    <app-tracker-paginated-table #firmTodosTable *ngIf="hasData" [setObj]="tableData" (onScroll)="handleScroll($event)" (onRowAction)="handleAction($event)"
                             (onSort)="sortByColumn($event)" (onInputSearchSelection)="optionSelected($event)" (onInputBlur)="updateInput($event)"
                             (onRowSelect)="handleSelect($event)"></app-tracker-paginated-table>
  </div>
</div>


<div class="actions" *ngIf="reveal['flag']">
  <div class="reveal-overlay" (click)="hideReveal('flag')" [ngClass]="{'tpiq-reveal': reveal['flag']}"></div>
  <div class="reveal actions-reveal" [ngClass]="{'tpiq-reveal': reveal['flag']}">
    <div class="row header">
      <div class="small-12 columns">
        <label *ngIf="flagValue === 'dueDate'" class="wakeup-text">Select Due Date for selected ToDo's !!</label>
        <label *ngIf="flagValue === 'priority'" class="wakeup-text">Select Priority for selected ToDo's !!</label>
        <label *ngIf="flagValue === 'delete'" class="wakeup-text">Are you sure to Delete selected ToDo's?</label>
      </div>
    </div>

    <div *ngIf="flagValue === 'dueDate'">
      <div class="row label-top">
        <div class="small-4 medium-3 columns">
          <label class="label-name label-top">Due Date</label>
        </div>
        <div class="small-4 medium-6 columns">
          <label>
            <input class="round-border" type="text" tpiq-custom-datepicker [container]="'todos_due_date'" [format]="'MM/DD/YYYY'" [mindate]="'past'" placeholder="Date" (valueChanged)="onBulkDueDateSelect($event)">
            <div id="todos_due_date"></div>
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="flagValue == 'priority'">
      <div class="row label-top">
        <div class="small-4 medium-3 columns">
          <label class="label-name label-top">Priority</label>
        </div>
        <div class="small-4 medium-6 columns">
          <label>
            <app-tpiq-select-dropdown [setData]="priorities" [setPlaceHolder]="'Select Priority'" [includeNone]="false" [setSearchKey]="'name'" [setValueKey]="'id'" (onValueSelect)="onBulkPrioritySelect($event)"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
    </div>

    <div class="row footer">
      <div class="small-12 medium-12 columns btn-row">
        <div class="text-right btn-wrapper" style="padding-right: 10px">
          <button class="button small" (click)="onBulkApply(flagValue)">APPLY</button>
          <button class="button small" style="background: #f1645a;" (click)="hideReveal('flag')">CANCEL</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['todoCreation']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['todoCreation']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'tpiq-reveal': reveal['todoCreation']}">
    <div class="header" style="height: 50px; background-color: #5376E3; padding: 15px; color: #fff;">
      <span class="float-left">Todo Creation</span>
      <span class="float-right pointer" (click)="hideReveal('todoCreation')">X</span>
    </div>
    <div class="body new-input-fields" style="padding: 15px;">
      <div class="row">
        <div class="medium-3 columns">
          <label>Client</label>
        </div>
        <div class="medium-9 columns">
          <label>
            <app-tpiq-select-dropdown [setData]="allClientsList" [includeNone]="false" (onValueSelect)="onClientSelect($event)"
                                   [setDefaultValue]="" [setSearchKey]="'clientName'" [setPlaceHolder]="'Select a client'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
      <div class="row"  style="padding-top: 0.5rem" *ngIf="selectedClientForTodoCreation">
        <div class="medium-3 columns">
          <label>Plan</label>
        </div>
        <div class="medium-9 columns">
          <label>
            <app-tpiq-select-dropdown [setData]="clientPlans" [includeNone]="false" (onValueSelect)="onClientPlanSelect($event)"
                                   [setDefaultValue]="" [setSearchKey]="'name'" [setPlaceHolder]="'Select a plan'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
          </label>
        </div>
      </div>
      <div class="row"  style="padding-top: 0.5rem" *ngIf="selectedPlan">
        <div class="medium-3 columns">
          <label>Strategy</label>
        </div>
        <div class="medium-9 columns">
          <label>
            <app-tpiq-select-dropdown [setData]="planStrategies" [includeNone]="false" (onValueSelect)="onPlanStrategySelect($event)"
                                   [setDefaultValue]="" [setSearchKey]="'strategyName'" [setPlaceHolder]="'Select a strategy'" [setValueKey]="'strategyId'"></app-tpiq-select-dropdown>
          </label>
          <span style="font-size: 12px;">Note: Strategies with goal task dates.</span>
        </div>
      </div>
      <ng-template [ngIf]="selectedPlanStrategy">
        <div class="row" style="padding-top: 0.5rem">
          <div class="medium-3 columns">
            <label>Title</label>
          </div>
          <div class="medium-9 columns">
            <label>
              <input type="text" [(ngModel)]="todoData.titile"/>
            </label>
          </div>
        </div>
        <div class="row" style="padding-top: 0.5rem">
          <div class="medium-3 columns">
            <label>Due Date</label>
          </div>
          <div class="medium-3 columns">
            <label>
              <input class="round-border" type="text" tpiq-custom-datepicker [format]="'MM/DD/YYYY'" [mindate]="'past'" (valueChanged)="setDueDate($event)" [ngModel]="todoData.dueDate" placeholder="Due Date" style="border-radius: 10px">
            </label>
          </div>
          <div class="medium-3 columns">
            <label>Priority</label>
          </div>
          <div class="medium-3 columns">
            <label>
              <app-tpiq-select-dropdown [includeNone]="false" [setData]="priorities" [setPlaceHolder]="'Priority'" [setSearchKey]="'name'" [setValueKey]="'id'" (onValueSelect)="setPriority($event)" [setDefaultValue]="todoData.priority"></app-tpiq-select-dropdown>
            </label>
          </div>
        </div>
        <div class="row" style="padding-top: 0.5rem">
          <div class="medium-3 columns">
            <label>Description</label>
          </div>
          <div class="medium-9 columns">
            <label>
              <div style="border: 1px solid  #cacaca !important;padding: 10px;color: #0a0a0a !important;" [froalaEditor]="todoDescriptionEditorOptions"  [(froalaModel)]="todoData.description"></div>
            </label>
          </div>
        </div>
      </ng-template>

      <div class="row">
        <div class="medium-12 columns">
          <button style="margin-top: 15px;" class="button small float-right" (click)="createTodo()">CREATE</button>
        </div>
      </div>
    </div>
  </div>
</div>
